import { render, staticRenderFns } from "./AccountAuth.vue?vue&type=template&id=212a8e18&"
import script from "./AccountAuth.vue?vue&type=script&lang=js&"
export * from "./AccountAuth.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/views/account-auth.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports